import React from "react";

import { Card } from "react-bootstrap"
import { appConfig } from "../config.js";

const CardStyled = ({ children, title }) => {

    const theme = appConfig.theme

    const header_border_bottom = "1px solid " + theme.backgroundColor

    // <Card bg="dark" style={{
    return (
        <Card style={{
            marginTop: "0em",
            fontSize: "18px",
            backgroundColor: theme.backgroundColorLighter1,
        }}>
            <Card.Header style={{ borderBottom: header_border_bottom }}>
                {title}
            </Card.Header>
            <br />
            <Card.Body style={{ paddingTop: "0em" }}>
                {children}
            </Card.Body>
        </Card>
    )
}

export default CardStyled
